import { render, staticRenderFns } from "./TabelaValoresPlanoParcelamento.vue?vue&type=template&id=5440eb36&"
import script from "./TabelaValoresPlanoParcelamento.vue?vue&type=script&lang=js&"
export * from "./TabelaValoresPlanoParcelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports